import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus3() {
  return (
    <BusDetailsCard
      busId="bus3"
      title="Bus 3 - Route Details"
      busName="Bus 3"
      vehicleNo="TN74C3234"
      backTo="/?buses=1"
    />
  );
}